<template>
	<footer
			:data-background-color="backgroundColor"
			class="footer footer-black footer-big">
		<div class="footer-top">
			<div class="center-wrap">
				<p class='footer-top__title'></p>
				<div class='footer-top__line-wrap'>
					<div class="footer-top__line">
						<div class='footer-top__line-fill'></div>
					</div>
					<span>Engineering progress</span><span>Enhancing lives</span>
				</div>
			</div>
			<div @click='back_top' class="footer-top__arrow md-elevation-15">
				<md-icon>keyboard_arrow_left</md-icon>
			</div>
		</div>
		<template>
			<div class="center-wrap">
				<div class="footer-items">
					<div class="footer-item">
						<div class="footer-logo">
							<div><img :src="logo" alt=""></div>
							REHAU
						</div>
						<p class='footer-about'>С 1948 года полимерные инновации REHAU успешно применяются в
							строительстве, производстве мебели, автомобилестроении и других индустриях промышленности и
							каждый день обеспечивают комфорт миллионов людей с позиции «невидимого чемпиона» - скрытые
							от глаз системы надежно несут свою службу. </p>
					</div>

					<div class="footer-item">
						<h5>Информация</h5>
						<div class="social-feed">
							<div class="footer-socials">
								<span>Socials:</span>
								<div class="footer-socials-wrap">
									<md-button @click="gotoLink('https://www.instagram.com/rehaurussia/')"
											   class="md-simple md-just-icon md-round"><i
											class="fab fa-instagram"></i></md-button>
									<md-button @click="gotoLink('https://www.facebook.com/rehau.ru/')"
											   class="md-simple md-just-icon md-round"><i
											class="fab fa-facebook-square"></i></md-button>
								</div>
							</div>
							<p class='footer-phone'>
								<md-icon>phone</md-icon>
								<a href="">+ 7 (800) 555 33 55</a></p>
							<p class='footer-adress'>
								<md-icon>pin_drop</md-icon>
								<a href="">г. Москва, ул. Угрешская д. 2 стр. 15</a></p>

						</div>
					</div>

					<div class="footer-item"></div>
				</div>
				<hr>

				<div class="flex flex-direction-row space-between footer-nav2">
					<nav>
						<ul class='footer-nav2__list'>
							<li>
								<a href="http://rehau.ru" rel="noreferrer" target="_blank">rehau.ru</a>
							</li>
							<li>
								<a href="http://rehau.com" rel="noreferrer" target="_blank">rehau.com</a>
							</li>
							<li>
								<a href="http://rehau-kitchen.ru" rel="noreferrer" target="_blank">rehau-kitchen.ru</a>
							</li>
							<li>
								<a href="http://shop-rehau.ru" rel="noreferrer" target="_blank">shop-rehau.ru</a>
							</li>
						</ul>
					</nav>
					<div class="copyright float-right">
						Copyright © 2018-{{ year }} REHAU.
					</div>
				</div>
			</div>
		</template>
		<div class="footer-bottom">
			<p>Информация, опубликованная на данном сайте, предназначена для любой аудитории, если иное не указано
				дополнительно в отношении отдельных материалов.</p>
		</div>
	</footer>
</template>
<script>
    export default {
        props: {
            backgroundColor: String,
            type: String,
            size: String,
        },
        data () {
            return {
                year: new Date().getFullYear(),
                logo: require('@/assets/images/footer-logo.png'),
            }
        },
        methods: {
            gotoLink (aLink) {
                window.location.href = aLink
            },
            back_top () {
                document.querySelector('body').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                })
            },
        },
    }
</script>
<style lang="scss" scoped>
	@import "@/assets/scss/material-kit/_colors.scss";

	div.center-wrap {
		width: 100%;
		max-width: 1140px;
		padding-left: 15px;
		padding-right: 15px;
		margin: 0px auto;
	}

	footer {
		margin-top: 25px;
		flex-direction: column;
		padding-top: 0px;
		padding-bottom: 0px;
	}

	.footer-top {
		background-color: $green;
		margin-bottom: 50px;

		> div.center-wrap {
			min-height: 100px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: -4px;

			.footer-top__title {
				color: #ffffff !important;
				font-size: 30px;
				font-weight: 500;
				margin-bottom: 0px;
			}

		}

		&__line-wrap {
			display: flex;
			flex-direction: column;

			span {
				text-align: left;
				font-size: 18px;
				font-weight: 500;

				&:last-child {
					color: #ffffff;
				}
			}

			.footer-top__line {
				height: 8px;
				background-color: #ffffff;
				min-width: 160px;
				margin-bottom: 5px;

				&-fill {
					width: 60%;
					background: #000000;
					height: 100%;
				}
			}
		}
	}

	.footer-logo {
		position: relative;
		color: #ffffff;
		font-weight: 900;
		font-size: 35px;
		padding-left: 33px;
		padding-top: 15px;
		margin-bottom: 20px;

		div {
			position: absolute;
			width: 32px;
			height: 34px;
			left: 0px;
			top: 0px;
		}

		img {
			max-width: 100%;
		}
	}


	.footer-socials {
		display: flex;
		align-items: center;

		span {
			color: #ffffff;
			font-weight: 400;
			font-size: 15px;

		}

		&-wrap {
			display: flex;

			div.md-ripple i {
				color: #ffffff !important;
				padding: 0px !important;
			}

		}
	}

	.footer-phone {
		display: flex;
		align-items: center;
		justify-content: flex-start;

		a {
			font-size: 17px;
			font-weight: 400;
			color: #e5e5e5 !important;
		}

		i {
			margin-left: 0px;
			margin-right: 0px;
		}

	}

	.footer-adress {
		display: flex;
		align-items: center;
		justify-content: flex-start;

		i {
			margin-left: 0px;
			margin-right: 0px;
		}

	}


	.footer-nav__list {
		display: flex;
		flex-direction: column;
	}

	.footer-nav__link {
		padding: 0px;
		line-height: 30px;
		margin-left: 0px;
		text-align: left;
	}

	footer h5 {
		text-transform: uppercase;
		font-family: "Roboto" !important;
	}


	.social-feed {
		margin-top: -5px;
	}


	div.footer-items {
		display: flex;
		justify-content: space-between
	}

	.footer-item {
		width: calc((100% - 90px) / 3);
		max-width: 280px;
		text-align: left;
	}

	.footer-about {
		font-size: 13px;
		line-height: 21px;
		text-align: left;
	}

	.footer-phone {
		margin-bottom: 15px;
		margin-top: 5px;
	}


	.footer-bottom {
		border-top: 1px solid rgba(255, 255, 255, 0.2);
		margin-top: 11px;
		background: #ffffff;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-left: 15px;
		padding-right: 15px;

		p {
			margin-bottom: 0px;
			color: #000000;
		}

	}

	.footer-top {
		position: relative;
	}

	.footer-top__arrow {
		position: absolute;
		background: #ffffff;
		width: 40px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		bottom: -20px;
		left: calc(50% - 20px);
		cursor: pointer;
	}

	.footer-top__arrow /deep/ i {
		color: $pink !important;
		transform: rotate(90deg);
		font-size: 30px !important;
	}

	@media screen and (max-width: 1100px) {
		.footer-top__arrow {
			bottom: -30px;
		}
	}


	@media screen and (max-width: 1000px) {
		.footer-item {
			width: calc(50% - 20px);
			max-width: 100%;
			margin-bottom: 10px;
		}

		.footer-item:nth-child(3) {
			width: 100%;
		}
		.footer-items {
			flex-wrap: wrap;
		}

		.footer-nav__list {
			flex-direction: row;
		}
		.footer-nav__link {
			margin-right: 20px;
		}
	}


	@media screen and (max-width: 800px) {
		.footer-top div.center-wrap {
			flex-direction: column;
			padding-top: 30px;
			padding-bottom: 50px;
		}

		.footer-top__title {
			margin-bottom: 20px !important;
			font-size: 24px !important;
		}

		.footer-top__arrow {
			bottom: -20px;
		}

		.footer-bottom p {
			max-width: 350px;
			font-size: 13px;
			line-height: 20px;
		}

		.footer-bottom {
			height: auto;
			padding-top: 10px;
			padding-bottom: 10px;
		}

	}


	@media screen and (max-width: 700px) {


		ul.footer-nav2__list {
			display: flex;
			flex-wrap: wrap;
		}

		ul.footer-nav2__list a {
			padding: 7px 20px;
		}

		.footer-nav2.flex-direction-row {
			display: flex;
			flex-direction: column !important;
			align-items: flex-start;
			max-width: 350px;
			margin: 0px auto;
		}


		.footer-items {
			flex-direction: column;
			align-items: center;
		}

		.footer-top div.center-wrap {
			align-items: flex-start;
			max-width: 350px;
			margin: 0px auto;
		}

		.footer-item {
			width: 100%;
			max-width: 350px;
			margin-bottom: 30px;
		}

		.footer-nav__list {
			flex-direction: column;
		}
		.footer-nav__link {
			margin-right: 0px;
		}
		.footer-item:nth-child(1) {
			order: 2;
			margin-bottom: 0px;
		}

		.footer-top__title {
			font-size: 19px !important;
		}
	}


	@media screen and (max-width: 600px) {
		.footer-top__title {
			font-size: 20px !important;
		}
	}

	@media screen and (max-width: 360px) {
		.footer-top__title {
			font-size: 18px !important;
		}
	}


</style>
